<dx-data-grid
    #dataGrid
    [dataSource]="dataSource"
    [keyExpr]="$localDataSource() ? $key() : undefined"
    [columns]="columns()"
    [summary]="$summary()"
    [dataRowTemplate]="$rowTemplate() ? 'dataRowTemplateName' : undefined"
    [showBorders]="false"
    [remoteOperations]="!$localDataSource()"
    [sorting]="{mode: 'none'}"
    [editing]="$editing()"
    [allowColumnResizing]="true"
    [columnAutoWidth]="$columnAutoWidth()"
    [rowAlternationEnabled]="true"
    [searchPanel]="{visible: true, width: '100%'}"
    [headerFilter]="{visible: $allowHeaderFiltering()}"
    (onRowPrepared)="onRowPrepared($event)"
    >

    <dxo-toolbar class="border-bottom">

        <!-- FILTERS -->
        <dxi-item location="before" name="searchPanel" />

        <dxi-item location="before">
            <div class="d-flex align-items-center gap-2">

                @for (item of $filterOptions(); track item) {
                    @if(item.editorType === 'dxButtonGroup'){
                        <dx-button-group [height]="48"
                            [items]="item.dataSource"
                            [keyExpr]="item.valueExpr"
                            [selectionMode]="item.selectionMode ?? 'single'"
                            [selectedItemKeys]="item.value"
                            (onItemClick)="onItemClick($event, item)"
                        />
                    }
                    @else {
                        <dx-lookup
                            [(value)]="item.value"
                            [placeholder]="item.value??item.label"
                            [hint]="item.label"
                            [dataSource]="item.dataSource"
                            [displayExpr]="item.displayExpr"
                            [valueExpr]="item.valueExpr"
                            [searchEnabled]="item.searchEnabled ?? true"
                            [showClearButton]="true"
                            [useItemTextAsTitle]="true"
                            [dropDownCentered]="false"
                            [dropDownOptions]="{minWidth: 200}"
                            [elementAttr]="{style: 'min-width: 120px'}"
                            (onValueChanged)="onFilter()"/>
                    }

                }
            </div>

        </dxi-item>
        <dxi-item location="before" cssClass="d-flex align-items-end justify-content-end">
            <dx-button *dxTemplate type="danger"
                stylingMode="outlined"
                [height]="48"
                icon="fa-solid fa-filter-circle-xmark"
                [text]="'COMMON.LABEL_CLEAR' | translate"
                [disabled]="!hasFilters || dataGrid.instance.getDataSource().isLoading()"
                (onClick)="clearFilters()"></dx-button>
        </dxi-item>

        <!-- SORT & PAGINATION -->
        <dxi-item location="after">
            <div class="d-flex text-secondary align-items-center h-100" *dxTemplate>
                @for(item of $sortingOptions(); track item){
                    <fieldset>
                        <button role="button"
                            type="button"
                            class="btn text-secondary rounded-0"
                            [ngClass]="item.label === currentSort ? 'fw-semibold' : 'fw-light'"
                            (click)="onSort(item.label, item.sortExpr)">{{item.label}}</button>
                    </fieldset>
                    @if(!$last){
                        <span class="px-1">|</span>
                    }
                }
            </div>
        </dxi-item>
        <dxi-item location="after">
            <div class="d-flex align-items-end justify-content-end gap-1">
                <ng-content select="[actions]"></ng-content>
                @if ($allowAdding()) {
                    <dx-button
                        [text]="$addingButtonText() | translate"
                        [icon]="$addingButtonIcon()"
                        type="default"
                        [height]="48"
                        (onClick)="onAddingClick.emit(true)"></dx-button>
                }
                @if($showRefresh()){
                    <dx-button icon="refresh"
                        type="normal"
                        hint="Refresh"
                        [height]="48"
                        [width]="48"
                        (onClick)="refresh()"></dx-button>
                }
            </div>
        </dxi-item>
    </dxo-toolbar>

    <dxo-paging [pageSize]="12"></dxo-paging>
    <dxo-pager
        [visible]="true"
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[12,24,48]"
        [showInfo]="true"
        [infoText]="'dataGrid.pager.infoText' | translate"
        displayMode="compact"></dxo-pager>

    <dxo-filter-panel [visible]="$filterPanel()" />
    <dxo-filter-row [visible]="$filterRow()" />
    <dxo-header-filter [visible]="$headerFilter()" />

    <!-- TEMPLATE -->
    @if ($rowTemplate()) {
        <ng-container *dxTemplate="let rowInfo of 'dataRowTemplateName'">
            <ng-template [ngTemplateOutlet]="$rowTemplate()" [ngTemplateOutletContext]="{rowInfo: rowInfo}"></ng-template>
        </ng-container>
    }

    @for (template of $cellTemplates(); track template.name) {
        <ng-container *dxTemplate="let rowInfo of template.name">
            <ng-template [ngTemplateOutlet]="template.template" [ngTemplateOutletContext]="{rowInfo: rowInfo}"></ng-template>
        </ng-container>
    }

</dx-data-grid>
<app-pagination *dxTemplate #pagination
    [(pageSize)]="pageSize"
    [(currentPage)]="currentPage"
    [pageCount]="dataGrid.instance.pageCount()"
    [totalRows]="dataGrid.instance.totalCount()"></app-pagination>
